module.exports = __webpack_public_path__ + "static/media/introduction_bg.5d8aee47.png";